/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSticker = createReactComponent("outline", "sticker", "IconSticker", [["path", { "d": "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8", "key": "svg-0" }], ["path", { "d": "M20 12a8 8 0 1 1 -8 -8", "key": "svg-1" }]]);

export { IconSticker as default };
//# sourceMappingURL=IconSticker.mjs.map
